import { render, staticRenderFns } from "./DataSidebar_automation.vue?vue&type=template&id=7faac31b&"
import script from "./DataSidebar_automation.vue?vue&type=script&lang=js&"
export * from "./DataSidebar_automation.vue?vue&type=script&lang=js&"
import style0 from "./DataSidebar_automation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports